import React, { useState } from 'react';
import styled from 'styled-components';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import InsufficientData from '../../components/InsufficientData';
import ModalCompetenciasEnem from '../../components/ModalCompetenciasEnem';
import { COMPETENCIAS_ENEM_DESCRICAO } from './avaliaConsts';

const StackedBarChart = ({ dados, tituloCompleto, subtitulo, minWidthScroll, media = false }) => {
  const [showModalObj, setShowModalObj] = useState({ isOpen: false, competenciaDataType: null });

  const new_data = (categories) => {
    if (categories) {
      let lista = categories.map((categorie) => (categorie.replace(/ /g, '<br>')))
      return lista
    }
  }

  const addClickEvent = {
    point: {
      events: {
        click: function () {
          setShowModalObj({ isOpen: true, competenciaDataCategory: COMPETENCIAS_ENEM_DESCRICAO[this.category] });
        }
      }
    }
  };

  const seriesConfig = dados && media ? [{ ...dados.medias, ...addClickEvent }] : dados.data;

  const options = {
    chart: {
      type: 'column',
      scrollablePlotArea: {
        minWidth: minWidthScroll ? minWidthScroll : 0
      },
    },
    title: {
      text: tituloCompleto ? `${tituloCompleto && tituloCompleto}` : '',
      align: 'left',
      style: {
        fontSize: '20px',
        fontFamily: 'Public Sans',
        fontWeight: 'bold',
      }
    },
    subtitle: {
      text: subtitulo ? subtitulo : '',
      align: 'left',
      fontSize: '20px',
      fontFamily: 'Public Sans',
    },
    xAxis: [{
      title: {
        text: 'Pontos'
      },
      type: 'category',
      crosshair: true,
      labels: {
        rotation: 0,
        style: {
          fontSize: '13px',
          fontFamily: 'openSans',
        }
      },
      categories: dados && new_data(dados.categories),
    }],
    yAxis: {
      max: (media ? 200 : 100),
      title: {
        text: 'Categorias'
      },
      stackLabels: {
        enabled: true,
        formatter: function () {
          if (this.stack === 'Médias') {
            return `${this.total} pontos`;
          } else {
            return `${Highcharts.numberFormat(this.total, 0)}%`;
          }
        }
      }
    },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || 'white',
      borderColor: 'none',
      shadow: false,
      borderRadius: '1px',
      symbolRadius: 0,
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: true
        },
      },
      series: {
        cursor: media && 'pointer',
      }
    },
    tooltip: {
      formatter: function () {
        return (
          '<b>' +
          this.series.name +
          ': ' +
          this.x +
          '</b><br/>' +
          this.series.name +
          ': ' +
          Highcharts.numberFormat(this.y, 2).replace('.', ',') + '%' +
          (media && '<br/>Clique para saber mais')
        );
      }
    },
    series: seriesConfig,
  };

  return dados !== undefined ? (
    <div
      style={{
        width: '97.5%',
        borderRadius: '8px',
        padding: '1rem',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <div style={{ width: '100%' }}>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          containerProps={{ style: { height: '700px' } }}
        />
      </div>
      {media && (
        <div
          style={{
            width: '97.5%',
            borderRadius: '8px',
            padding: '1rem',
            display: 'flex',
            alignItems: 'space-between',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          {showModalObj.isOpen
            && <ModalCompetenciasEnem showModalObj={showModalObj}
              setShowModalObj={setShowModalObj} />
          }
        </div>
      )}
    </div>
  ) : (
    <div style={{ height: 'auto' }}>
      <InsufficientData />
    </div>
  );
};

export default styled(StackedBarChart)`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #3e2;
  .div {
    color: #3e2;
  }
`;